import { render, staticRenderFns } from "./supportView.vue?vue&type=template&id=5ba7a5eb&"
import script from "./supportView.vue?vue&type=script&lang=js&"
export * from "./supportView.vue?vue&type=script&lang=js&"
import style0 from "./supportView.vue?vue&type=style&index=0&id=5ba7a5eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports